import FormGroup from "../pages/formGroup/FormGroup";
import FormGroupField from "../pages/formGroup/FormGroupField";
import IRoutes from "../interfaces/IRoutes";

// const FeedPage = React.lazy(() => import('../pages/feed/Feed'));

const FormGRoupRoutes: Array<IRoutes> = [
  {
    element: <FormGroup />,
    path: "/form-group",
  },
  {
    element: <FormGroupField />,
    path: "/form-group/create",
  },
  {
    element: <FormGroupField />,
    path: "/form-group/edit/:id",
  }
];

export default FormGRoupRoutes;
